import { useContext } from 'react'
import { useIntl } from 'react-intl'
import GeoContext from 'contexts/geoContext'
import { LUXURY_ESCAPES } from 'constants/brands'
import config from 'constants/config'
import HeadData from 'components/Common/HeadData'
import productLabels from 'i18n/productLabels'

function TourHeadData() {
  const { currentRegionCode } = useContext(GeoContext)
  const intl = useIntl()

  const headTitle = config.BRAND === LUXURY_ESCAPES
    ? intl.formatMessage(
        {
          id: 'a7PcUa2wD5EKBV_cv4Vk',
          defaultMessage: 'Luxury Tours',
          description: 'Page title for the tours page on the Luxury Escapes brand',
        },
      )
    : intl.formatMessage(productLabels.tours)

  const pageTitle = intl.formatMessage(
    {
      id: 'Hgb7ViVJ4mWjH0zWneHW',
      defaultMessage: '{headTitle} - {siteTitle} {regionCode}',
      description: 'Full page title for tours page combining tour title, site name and region',
    },
    { headTitle, siteTitle: config.title, regionCode: currentRegionCode },
  )

  return <HeadData title={pageTitle} />
}

export default TourHeadData
